import ReactSpeedometer from "react-d3-speedometer";

export default function SpeedGauge({ value }) {
  return (
    <ReactSpeedometer
      width={180}
      height={130}
      maxValue={220}
      value={value}
      needleColor="red"
      startColor="green"
      endColor="red"
      segments={10}
      currentValueText={`${value.toFixed(0)} km/h`}
    />
  );
}
